import React, { memo, useRef } from 'react';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';

const ToggleSelect = ({
  img,
  checked,
  name,
  value,
  onChange,
  onBlur,
  disabled,
  nameDisplay,
  containerStyle,
  namingStyle,
  addClasses = ''
}) => {
  const myRadio = useRef(null);

  const fireRef = () => {
    myRadio?.current?.click();
  };
  return (
    <>
      <div
        onClick={() => {
          if (!disabled) fireRef();
        }}
        className={
          (checked ? 'border-green-1000 bg-green-100 ' : 'border-grey-1009 ') +
          ' relative w-25 h-20 rounded-lg border ' +
          (disabled && ' cursor-not-allowed ') +
          addClasses
        }
        style={containerStyle}
      >
        <div className="absolute top-0 right-0 mr-1 mt-1">
          <RadioButton
            ref={myRadio}
            name={name}
            onChange={onChange}
            checked={checked}
            value={value}
            onBlur={onBlur}
          />
        </div>
        {img ? (
          <div className="h-11 w-11 mx-auto mt-5">
            <img className="w-full h-full block " src={img} alt={name} />
          </div>
        ) : null}
        {nameDisplay ? (
          <div className="mx-auto text-center px-3">
            <p
              className="font-robot font-normal text-base text-grey-920 mx-auto "
              style={namingStyle}
            >
              {nameDisplay}
            </p>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default memo(ToggleSelect);
